document.addEventListener('DOMContentLoaded', function () {

  // ---- Search Queries ----
  // Shopify's storefront search is loose: an unquoted word matches the machines
  // we expect and then pads the results with the rest of the catalogue, so
  // /search?q=Polar came back with every machine in stock. Quoting each word
  // makes the match exact (62 Polars instead of 930 machines). Item IDs and
  // years are the exception: they're four digits and a quoted number never
  // matches the variant SKU, so searching 3738 would find nothing. Model sizes
  // (115, 92, 78) are short, so quoting those keeps "polar 115" tight.
  function buildSearchQuery(raw) {
    return String(raw || '')
      .replace(/"/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map(term => (/^\d{4,}$/.test(term) ? term : '"' + term + '"'))
      .join(' ');
  }

  // The dropdown runs while someone is still typing, so the last word is a
  // prefix: "pola" has to find the Polars. A quoted word never matches a
  // prefix, so the word being typed goes out as pola* instead. Shopify pads a
  // wildcard match with the rest of the catalogue, which is why the dropdown
  // filters what comes back against what was typed.
  function buildSuggestQuery(raw) {
    const terms = String(raw || '').replace(/"/g, ' ').trim().split(/\s+/).filter(Boolean);
    if (!terms.length) return '';
    const lastTerm = terms.pop();
    return terms
      .map(term => buildSearchQuery(term))
      .concat(lastTerm + '*')
      .join(' ');
  }

  // Visitors also arrive on /search from Google, a bookmark or a form that
  // submitted before this script loaded, so quote the terms here too. Shoppers
  // are looking for machines, so searches are limited to products — news posts
  // don't belong in the results grid.
  if (window.location.pathname === '/search') {
    const searchUrl = new URL(window.location.href);
    const rawTerms = searchUrl.searchParams.get('q');
    const quotedTerms = buildSearchQuery(rawTerms);
    const needsType = searchUrl.searchParams.get('type') !== 'product';
    if (quotedTerms && (quotedTerms !== rawTerms || needsType)) {
      searchUrl.searchParams.set('q', quotedTerms);
      searchUrl.searchParams.set('type', 'product');
      window.location.replace(searchUrl.toString());
      return;
    }
  }

  // Every search form posts to /search, so quote what was typed on the way out
  // and keep the search on products.
  document.querySelectorAll('form[action="/search"]').forEach(form => {
    if (!form.querySelector('input[name="type"]')) {
      const typeInput = document.createElement('input');
      typeInput.type = 'hidden';
      typeInput.name = 'type';
      typeInput.value = 'product';
      form.appendChild(typeInput);
    }
    form.addEventListener('submit', function () {
      const keywordInput = form.querySelector('input[name="q"]');
      if (keywordInput) keywordInput.value = buildSearchQuery(keywordInput.value);
    });
  });

  // ---- Mobile Menu ----
  const mobileBtn = document.getElementById('mobile-menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  if (mobileBtn && mobileMenu) {
    mobileBtn.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('is-open');
      document.body.classList.toggle('mobile-menu-open', isOpen);
    });
  }

  // ---- Mobile Menu Dropdowns ----
  const mobileToggles = document.querySelectorAll('.mobile-nav-list__toggle');
  mobileToggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const parentRow = toggle.closest('.mobile-nav-list__parent-row');
      const dropdown = parentRow ? parentRow.nextElementSibling : null;
      if (dropdown && dropdown.classList.contains('mobile-nav-list__dropdown')) {
        const isOpen = dropdown.classList.toggle('is-open');
        toggle.classList.toggle('is-active', isOpen);
      }
    });
  });

  // ---- Categories Dropdown (JS-controlled with grace-period close delay) ----
  document.querySelectorAll('.nav-list__item--has-dropdown').forEach(item => {
    let closeTimer = null;
    const open = () => {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      item.classList.add('is-open');
    };
    const scheduleClose = () => {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(() => item.classList.remove('is-open'), 300);
    };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', scheduleClose);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', scheduleClose);
  });

  // ---- Sticky Header ----
  const header = document.getElementById('site-header');
  if (header) {
    const topBarHeight = document.querySelector('.top-bar') ? 36 : 0;
    window.addEventListener('scroll', () => {
      if (window.scrollY > topBarHeight + 10) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }
    });
  }

  // ---- Testimonials Slider ----
  const slides = document.querySelectorAll('.testimonials__slide');
  const prevBtn = document.getElementById('prev-testimonial');
  const nextBtn = document.getElementById('next-testimonial');

  if (slides.length > 1 && prevBtn && nextBtn) {
    let current = 0;
    let timer = null;

    const showSlide = (i) => {
      const prevActive = current;
      current = i;
      slides.forEach((s, idx) => {
        s.classList.remove('is-active', 'is-leaving');
        if (idx === current) {
          s.classList.add('is-active');
        } else if (idx === prevActive) {
          s.classList.add('is-leaving');
        }
      });
    };

    const nextSlide = () => {
      showSlide((current + 1) % slides.length);
    };

    const prevSlide = () => {
      showSlide((current - 1 + slides.length) % slides.length);
    };

    const startTimer = () => {
      if (timer) clearInterval(timer);
      timer = setInterval(nextSlide, 4500); // auto-rotate every 4.5 seconds
    };

    prevBtn.addEventListener('click', () => {
      prevSlide();
      startTimer(); // reset timer on click
    });

    nextBtn.addEventListener('click', () => {
      nextSlide();
      startTimer(); // reset timer on click
    });

    // Start auto-rotation
    startTimer();
  }

  // ---- Smooth scroll anchors ----
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function(e) {
      const t = document.querySelector(this.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  // ---- Close search modal on Escape ----
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') document.getElementById('search-modal')?.classList.remove('is-open');
  });

  // ---- Header Search Modal Toggle ----
  const headerSearchToggle = document.getElementById('header-search-toggle-btn');
  const headerSearchModal = document.getElementById('search-modal');
  const headerSearchInputInput = document.getElementById('header-search-input');
  if (headerSearchToggle && headerSearchModal) {
    headerSearchToggle.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = headerSearchModal.classList.toggle('is-open');
      if (isOpen && headerSearchInputInput) {
        setTimeout(() => {
          headerSearchInputInput.focus();
        }, 100);
      }
    });
  }

  // ---- Share menus (product cards and product page) ----
  // Share targets are buttons that open their URL from script, not links. As
  // <a rel="nofollow"> they put three external hrefs into every product card,
  // over 6,000 across the site, each one flagged by the SEO audit and of no use
  // to a crawler. The card menu is also built the first time it is opened
  // instead of being rendered into each of up to 250 cards, where its icons
  // were a large share of every collection page's HTML.
  const SHARE_ICONS = {
    linkedin: "<svg aria-hidden=\"true\" focusable=\"false\" viewBox=\"0 0 24 24\" fill=\"white\"><path d=\"M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z\"/><circle cx=\"4\" cy=\"4\" r=\"2\"/></svg>",
    twitter: "<svg aria-hidden=\"true\" focusable=\"false\" viewBox=\"0 0 24 24\" fill=\"white\"><path d=\"M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z\"/></svg>",
    whatsapp: "<svg aria-hidden=\"true\" focusable=\"false\" viewBox=\"0 0 24 24\" fill=\"white\"><path d=\"M17.6 6.32A7.85 7.85 0 0 0 12.05 4a7.94 7.94 0 0 0-6.9 11.86L4 20l4.27-1.12a7.93 7.93 0 0 0 3.78.96h.01a7.94 7.94 0 0 0 5.54-13.52zM12.06 18.3a6.6 6.6 0 0 1-3.37-.92l-.24-.14-2.5.66.67-2.44-.16-.25a6.6 6.6 0 0 1 10.2-8.2 6.55 6.55 0 0 1 1.94 4.67 6.63 6.63 0 0 1-6.54 6.62zm3.6-4.95c-.2-.1-1.16-.57-1.34-.64-.18-.07-.31-.1-.44.1-.13.2-.5.63-.62.76-.11.13-.23.14-.42.05-.2-.1-.83-.3-1.58-.97a5.93 5.93 0 0 1-1.1-1.36c-.11-.2 0-.3.1-.4.1-.1.23-.27.34-.4.11-.14.15-.24.22-.4.07-.16.04-.3-.02-.4-.07-.1-.6-1.45-.82-1.93-.22-.5-.44-.43-.6-.44h-.5c-.18 0-.46.07-.63.27a2.04 2.04 0 0 0-.64 1.5c0 .9.65 1.77.74 1.9.1.13 1.27 1.93 3.07 2.71 1.8.78 1.8.52 2.13.49.33-.03 1.07-.43 1.22-.85.15-.42.15-.78.1-.85-.04-.08-.18-.13-.38-.23z\"/></svg>",
    email: "<svg aria-hidden=\"true\" focusable=\"false\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"white\" stroke-width=\"2\"><path d=\"M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z\"/><polyline points=\"22,6 12,13 2,6\"/></svg>",
    copy: "<svg aria-hidden=\"true\" focusable=\"false\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"white\" stroke-width=\"2\"><rect x=\"9\" y=\"9\" width=\"13\" height=\"13\" rx=\"2\"/><path d=\"M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1\"/></svg>"
  };

  const buildCardShareMenu = (menu) => {
    const pageUrl = menu.dataset.shareUrl;
    const url = encodeURIComponent(pageUrl);
    const title = encodeURIComponent(menu.dataset.shareTitle || '');
    const target = (href, mod, label, icon) =>
      `<button type="button" class="share-menu__link${mod ? ' share-menu__link--' + mod : ''}" data-share-href="${href}" aria-label="${label}">${icon}</button>`;
    menu.innerHTML =
      target(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`, '', 'Share on LinkedIn', SHARE_ICONS.linkedin) +
      target(`https://twitter.com/intent/tweet?url=${url}&amp;text=${title}`, '', 'Share on Twitter', SHARE_ICONS.twitter) +
      target(`https://wa.me/?text=${title}%20${url}`, 'whatsapp', 'Share on WhatsApp', SHARE_ICONS.whatsapp) +
      target(`mailto:?subject=${title}&amp;body=${url}`, 'email', 'Share via Email', SHARE_ICONS.email) +
      `<button type="button" class="share-menu__link share-menu__link--copy js-copy-link" data-product-url="${pageUrl.replace(/"/g, '&quot;')}" aria-label="Copy link" title="Copy link">${SHARE_ICONS.copy}</button>`;
  };

  // Delegated, so it also covers cards the AJAX filters render later.
  document.addEventListener('click', (e) => {
    const copyBtn = e.target.closest('.js-copy-link');
    if (copyBtn) {
      navigator.clipboard.writeText(copyBtn.getAttribute('data-product-url')).then(() => {
        const original = copyBtn.innerHTML;
        copyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';
        setTimeout(() => { copyBtn.innerHTML = original; }, 1500);
      });
      return; // keep the menu open so the tick is visible
    }

    const shareTarget = e.target.closest('[data-share-href]');
    if (shareTarget) {
      const href = shareTarget.getAttribute('data-share-href');
      if (href.startsWith('mailto:')) window.location.href = href;
      else window.open(href, '_blank', 'noopener');
    }

    const toggle = e.target.closest('.js-share-toggle');
    const wrap = toggle && toggle.closest('.product-card__share-wrap');
    const wasOpen = wrap && wrap.classList.contains('is-open');
    document.querySelectorAll('.product-card__share-wrap.is-open').forEach(w => w.classList.remove('is-open'));
    if (wrap && !wasOpen) {
      const menu = wrap.querySelector('.product-card__share-menu');
      if (menu && !menu.childElementCount) buildCardShareMenu(menu);
      wrap.classList.add('is-open');
    }
  });

  // ---- Share buttons (product detail page) ----
  document.querySelectorAll('[data-product-url]:not(.js-copy-link)').forEach(btn => {
    btn.addEventListener('click', () => {
      const url = window.location.origin + btn.getAttribute('data-product-url');
      navigator.share ? navigator.share({ title: document.title, url }) 
        : navigator.clipboard.writeText(url).then(() => alert('Link copied!'));
    });
  });

  // ---- Download All Pictures (zips all product images client-side) ----
  const downloadBtn = document.getElementById('download-all-pictures-btn');
  if (downloadBtn) {
    downloadBtn.addEventListener('click', async () => {
      const label = document.getElementById('download-all-pictures-label');
      let images = [];
      try {
        images = JSON.parse(downloadBtn.getAttribute('data-images') || '[]');
      } catch (e) { images = []; }

      if (!images.length) return;

      const originalLabel = label.textContent;
      downloadBtn.disabled = true;

      try {
        if (typeof JSZip === 'undefined') {
          // Fallback: JSZip failed to load — open each image in a new tab
          label.textContent = 'OPENING IMAGES...';
          images.forEach(url => window.open(url, '_blank'));
          return;
        }

        const zip = new JSZip();
        const title = (downloadBtn.getAttribute('data-product-title') || 'machine')
          .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

        for (let i = 0; i < images.length; i++) {
          label.textContent = `PREPARING ${i + 1} / ${images.length}...`;
          try {
            const res = await fetch(images[i]);
            const blob = await res.blob();
            const ext = (images[i].split('.').pop().split('?')[0] || 'jpg').slice(0, 4);
            zip.file(`${title}-${i + 1}.${ext}`, blob);
          } catch (err) {
            console.warn('Could not fetch image for zip:', images[i], err);
          }
        }

        label.textContent = 'ZIPPING...';
        const content = await zip.generateAsync({ type: 'blob' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(content);
        link.download = `${title}-photos.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        console.error('Zip download failed:', err);
        alert('Could not prepare the zip download. Opening images individually instead.');
        images.forEach(url => window.open(url, '_blank'));
      } finally {
        label.textContent = originalLabel;
        downloadBtn.disabled = false;
      }
    });
  }

  // ---- Grid / List view toggle (collection & search pages) ----
  document.querySelectorAll('.collection-toolbar__view-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const view = btn.getAttribute('data-view');
      const grid = document.getElementById('products-grid');
      if (!grid) return;

      document.querySelectorAll('.collection-toolbar__view-btn').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      if (view === 'list') {
        grid.classList.add('is-list-view');
      } else {
        grid.classList.remove('is-list-view');
      }
    });
  });

  // ---- Hero Slider ----
  const heroSlider = document.getElementById('hero-slider');
  if (heroSlider) {
    const slides = Array.from(heroSlider.querySelectorAll('.hero-slide'));
    const dots = Array.from(heroSlider.querySelectorAll('.hero-slider__dot'));
    const prevBtn = heroSlider.querySelector('.hero-slider__arrow--prev');
    const nextBtn = heroSlider.querySelector('.hero-slider__arrow--next');
    let current = 0;
    let autoplayTimer = null;

    const autoplayEnabled = heroSlider.getAttribute('data-autoplay') !== 'false';
    const autoplaySpeed = parseInt(heroSlider.getAttribute('data-autoplay-speed'), 10) || 6000;

    function showSlide(index) {
      if (slides.length === 0) return;
      const newIndex = (index + slides.length) % slides.length;

      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      // Pause any playing video on the outgoing slide
      const outgoingVideo = slides[current].querySelector('video');
      if (outgoingVideo) outgoingVideo.pause();

      current = newIndex;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');

      // Play video on the incoming slide if present
      const incomingVideo = slides[current].querySelector('video');
      if (incomingVideo) incomingVideo.play().catch(() => {});
    }

    function startAutoplay() {
      if (!autoplayEnabled || slides.length <= 1) return;
      stopAutoplay();
      autoplayTimer = setInterval(() => showSlide(current + 1), autoplaySpeed);
    }
    function stopAutoplay() {
      if (autoplayTimer) clearInterval(autoplayTimer);
    }

    if (prevBtn) prevBtn.addEventListener('click', () => { showSlide(current - 1); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { showSlide(current + 1); startAutoplay(); });
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => { showSlide(i); startAutoplay(); });
    });

    // Pause autoplay while the user is interacting/hovering with the slider
    heroSlider.addEventListener('mouseenter', stopAutoplay);
    heroSlider.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  }

  // ---- Live Search ----
  // As the user types a machine name or Item ID, render the matching machines
  // from the search-suggestions section (available first, then pending, then
  // sold) and show them in a dropdown. Clicking a result navigates straight to
  // that product page.
  function initPredictiveSearch(searchInput, searchResults) {
    if (!searchInput || !searchResults) return;

    let searchDebounce = null;
    let currentRequest = null;

    function clearResults() {
      searchResults.innerHTML = '';
      searchResults.classList.remove('is-open');
    }

    searchInput.addEventListener('input', function () {
      const query = this.value.trim();

      if (searchDebounce) clearTimeout(searchDebounce);

      if (query.length < 2) {
        clearResults();
        return;
      }

      searchDebounce = setTimeout(async () => {
        try {
          if (currentRequest) currentRequest.abort();
          const controller = new AbortController();
          currentRequest = controller;

          const res = await fetch(
            `/search?q=${encodeURIComponent(buildSuggestQuery(query))}&type=product&section_id=search-suggestions`,
            { signal: controller.signal }
          );
          if (!res.ok) throw new Error('Search request failed');
          const html = await res.text();
          if (controller !== currentRequest || searchInput.value.trim() !== query) return;

          // Keep the machines whose name or Item ID carries every word typed,
          // which drops the ones Shopify padded the wildcard match with.
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const words = query.toLowerCase().split(/\s+/).filter(Boolean);
          const matches = Array.from(doc.querySelectorAll('.search-suggestions .search-result'))
            .filter(result => {
              const label = (result.textContent || '').toLowerCase();
              return words.every(word => label.indexOf(word) !== -1);
            })
            .slice(0, 8);

          if (matches.length) {
            searchResults.innerHTML = '';
            matches.forEach(match => searchResults.appendChild(document.importNode(match, true)));
          } else {
            searchResults.innerHTML = '<div class="search-modal__no-results">No machines found.</div>';
          }
          searchResults.classList.add('is-open');
        } catch (err) {
          if (err.name !== 'AbortError') console.error('Live search failed:', err);
        }
      }, 250);
    });

    // Close results when clicking outside
    document.addEventListener('click', (e) => {
      if (!searchResults.contains(e.target) && e.target !== searchInput) {
        clearResults();
      }
    });

    // Clear results when the search modal closes
    document.querySelectorAll('.search-modal__close, #search-modal').forEach(el => {
      el.addEventListener('click', (e) => {
        if (e.target.id === 'search-modal' || e.target.classList.contains('search-modal__close')) {
          clearResults();
          searchInput.value = '';
        }
      });
    });
  }

  // Initialize for header search
  initPredictiveSearch(
    document.getElementById('header-search-input'),
    document.getElementById('header-search-results')
  );

  // Initialize for homepage search bar
  initPredictiveSearch(
    document.getElementById('search-bar-input'),
    document.getElementById('search-bar-results')
  );

  // Initialize for search page & collection page search bar
  const searchPageInput = document.getElementById('search-page-input');
  const searchPageResults = document.getElementById('search-page-results');
  if (searchPageInput && searchPageResults) {
    initPredictiveSearch(searchPageInput, searchPageResults);
  }

  // Clear button logic for search page keyword input
  const searchPageClear = document.getElementById('search-page-clear');
  if (searchPageInput && searchPageClear) {
    searchPageInput.addEventListener('input', () => {
      searchPageClear.style.display = searchPageInput.value ? 'block' : 'none';
    });
    searchPageClear.addEventListener('click', () => {
      searchPageInput.value = '';
      searchPageClear.style.display = 'none';
      searchPageInput.focus();
      if (searchPageResults) {
        searchPageResults.innerHTML = '';
        searchPageResults.classList.remove('is-open');
      }
    });
    if (searchPageInput.value) {
      searchPageClear.style.display = 'block';
    }
  }

  // ---- Scroll-triggered Animations ----
  const scrollObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const delay = parseInt(el.getAttribute('data-delay') || '0', 10);
        setTimeout(() => {
          el.classList.add('is-visible');
        }, delay);
        scrollObserver.unobserve(el);
      }
    });
  }, { threshold: 0.05 });

  document.querySelectorAll('.animate-on-scroll').forEach(el => scrollObserver.observe(el));

  // ---- Stat Counter Animations ----
  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const targetVal = el.getAttribute('data-target') || el.textContent;
        const numberMatch = targetVal.match(/\d+/);
        if (!numberMatch) return;

        const endValue = parseInt(numberMatch[0], 10);
        const prefix = targetVal.substring(0, numberMatch.index);
        const suffix = targetVal.substring(numberMatch.index + numberMatch[0].length);

        let startValue = 0;
        const duration = 2000; // 2 seconds
        const startTime = performance.now();

        function updateCounter(currentTime) {
          const elapsedTime = currentTime - startTime;
          if (elapsedTime >= duration) {
            el.textContent = prefix + endValue + suffix;
            return;
          }
          const progress = elapsedTime / duration;
          const easeProgress = 1 - Math.pow(1 - progress, 3); // Ease out cubic
          const currentValue = Math.floor(easeProgress * endValue);
          el.textContent = prefix + currentValue + suffix;
          requestAnimationFrame(updateCounter);
        }

        requestAnimationFrame(updateCounter);
        counterObserver.unobserve(el);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.js-counter').forEach(el => counterObserver.observe(el));

  // ---- Main Search Bar Form Submission ----
  document.querySelectorAll('.search-bar__form').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const keywordInput = form.querySelector('input[name="q"]');
      const categorySelect = form.querySelector('select[name="category"]');
      const brandSelect = form.querySelector('select[name="brand"]');
      const colorSelect = form.querySelector('select[name="color"]');

      const keyword = keywordInput ? keywordInput.value.trim() : '';
      const category = categorySelect ? categorySelect.value : '';
      const brand = brandSelect ? brandSelect.value : '';
      const color = colorSelect ? colorSelect.value : '';

      if (!keyword) {
        // Construct collection URL
        let url = category ? `/collections/${category}` : '/collections/all';
        const tags = [];
        if (brand) tags.push(brand);

        if (tags.length > 0) {
          url += '/' + tags.join('+');
        }
        if (color) {
          url += `?color=${color}`;
        }
        window.location.href = url;
      } else {
        // Construct Shopify search query
        let query = keyword;
        if (category) query += ` collection:${category}`;
        if (brand) query += ` vendor:${brand}`;
        
        let url = `/search?q=${encodeURIComponent(query)}`;
        if (color) {
          url += `&color=${color}`;
        }
        window.location.href = url;
      }
    });
  });

  // Wrap asterisks in red color span for required fields
  document.querySelectorAll('.form-field__label').forEach(label => {
    if (label.innerHTML.includes('*')) {
      label.innerHTML = label.innerHTML.replace('*', '<span class="form-field__required">*</span>');
    }
  });

  // Order cards the same way the server does: available, then pending, then
  // sold, and inside each group by stock number. The filtered view stitches
  // several pages together, so without the stock tiebreaker the cards keep the
  // order the pages happened to arrive in.
  function sortCardsByStatusThenStock(cards) {
    const order = { 'available': 1, 'pending': 2, 'sold': 3 };
    const oldestFirst = new URL(window.location.href).searchParams.get('sort_by') === 'created-ascending';
    cards.sort((a, b) => {
      let statusA = a.getAttribute('data-status') || 'available';
      let statusB = b.getAttribute('data-status') || 'available';
      if (statusA === 'sale pending') statusA = 'pending';
      if (statusB === 'sale pending') statusB = 'pending';
      const wA = order[statusA] || 4;
      const wB = order[statusB] || 4;
      if (wA !== wB) return wA - wB;
      const sA = parseInt(a.getAttribute('data-stock'), 10) || 0;
      const sB = parseInt(b.getAttribute('data-stock'), 10) || 0;
      return oldestFirst ? sA - sB : sB - sA;
    });
    return cards;
  }

  // ---- AJAX Real-time Filtering (Collections & Search) ----
  function fetchAjaxFilter(url) {
    // Update URL in browser
    window.history.pushState({ path: url }, '', url);
    
    const grid = document.getElementById('products-grid');
    if (grid) grid.style.opacity = '0.3';

    fetch(url)
      .then(r => r.text())
      .then(html => {
         const parser = new DOMParser();
         const doc = parser.parseFromString(html, 'text/html');
         
         // Replace products grid
         const newGrid = doc.getElementById('products-grid');
         const mainContainer = document.querySelector('.collection-main');
         
         if (newGrid && grid) {
           grid.innerHTML = newGrid.innerHTML;
           grid.style.opacity = '1';
         } else if (newGrid && !grid && mainContainer) {
           mainContainer.innerHTML = newGrid.outerHTML; // If empty state was there
         } else if (!newGrid && grid) {
           grid.outerHTML = '<div class="products-grid" id="products-grid"><div class="collection-empty"><p>No results found.</p></div></div>';
         }

         // Restore Grid/List view state
         const activeView = document.querySelector('.collection-toolbar__view-btn.is-active');
         if (activeView && activeView.getAttribute('data-view') === 'list') {
           const activeGrid = document.getElementById('products-grid');
           if (activeGrid) activeGrid.classList.add('is-list-view');
         }

         // Replace count
         const countEl = document.querySelector('.collection-toolbar__count');
         const newCountEl = doc.querySelector('.collection-toolbar__count');
         if (countEl && newCountEl) countEl.innerHTML = newCountEl.innerHTML;
         
         // Replace pagination
         const paginationEl = document.querySelector('.pagination');
         const newPaginationEl = doc.querySelector('.pagination');
         if (paginationEl && newPaginationEl) {
           paginationEl.innerHTML = newPaginationEl.innerHTML;
         } else if (paginationEl && !newPaginationEl) {
           paginationEl.remove();
         } else if (!paginationEl && newPaginationEl) {
           const activeGrid = document.getElementById('products-grid');
           if (activeGrid) activeGrid.after(newPaginationEl);
         }

         // Update filter selects options so they carry the new URL states
         const oldSelects = document.querySelectorAll('.js-filter-select');
         const newSelects = doc.querySelectorAll('.js-filter-select');
         oldSelects.forEach((select, i) => {
           if (newSelects[i]) {
             select.innerHTML = newSelects[i].innerHTML;
           }
         });

         // --- NEW LOGIC: Client-Side Filtering & Aggregation ---
         const targetUrlObj = new URL(url, window.location.origin);
         const filterStatus = targetUrlObj.searchParams.get('status');
         const filterColor = targetUrlObj.searchParams.get('color');
         const filterSearch = targetUrlObj.searchParams.get('q');
         const hasFilter = filterStatus || filterColor || filterSearch;


         if (hasFilter) {
           let maxPage = 1;
           if (newPaginationEl) {
               newPaginationEl.querySelectorAll('.pagination__link').forEach(link => {
                  const pageNum = parseInt(link.innerText);
                  if (!isNaN(pageNum) && pageNum > maxPage) {
                     maxPage = pageNum;
                  }
               });
           }
           
           if (maxPage > 1) {
             const activeGrid = document.getElementById('products-grid');
             const promises = [];
             for (let p = 2; p <= maxPage; p++) {
               const pageUrl = new URL(url, window.location.origin);
               pageUrl.searchParams.delete('status'); // Fetch raw pages
               pageUrl.searchParams.delete('color');
               pageUrl.searchParams.set('page', p);
               promises.push(
                 fetch(pageUrl.toString()).then(r => r.text()).then(pageHtml => {
                   const pDoc = parser.parseFromString(pageHtml, 'text/html');
                   const pGrid = pDoc.getElementById('products-grid');
                   if (pGrid) {
                     Array.from(pGrid.children).forEach(child => {
                        activeGrid.appendChild(child);
                     });
                   }
                 })
               );
             }
             
             // Wait for all pages to load, then sort, filter and update count
             Promise.all(promises).then(() => {
                const allCards = Array.from(activeGrid.children);
                
                // 1. Filter
                const filteredCards = allCards.filter(card => {
                   let match = true;
                   if (filterStatus) {
                      let s = card.getAttribute('data-status') || 'available';
                      if (s === 'sale pending') s = 'pending';
                      if (s !== filterStatus) match = false;
                   }
                   if (filterColor) {
                      let c = card.getAttribute('data-color') || '';
                      if (c !== filterColor) match = false;
                   }
                   return match;
                });

                // 2. Sort
                sortCardsByStatusThenStock(filteredCards);
                
                // 3. Re-append in correct order
                activeGrid.innerHTML = '';
                filteredCards.forEach(card => activeGrid.appendChild(card));

                const finalCount = filteredCards.length;
                const countEl = document.querySelector('.collection-toolbar__count');
                if (countEl) countEl.innerHTML = finalCount + ' Machine' + (finalCount !== 1 ? 's' : '');
             });

             // Remove pagination from UI since we aggregated everything
             const paginationEl = document.querySelector('.pagination');
             if (paginationEl) paginationEl.remove();
           } else {
               // If only 1 page but has filter, we still need to filter it!
               const activeGrid = document.getElementById('products-grid');
               if (activeGrid) {
                 const allCards = Array.from(activeGrid.children);
                 const filteredCards = allCards.filter(card => {
                     let match = true;
                     if (filterStatus) {
                        let s = card.getAttribute('data-status') || 'available';
                        if (s === 'sale pending') s = 'pending';
                        if (s !== filterStatus) match = false;
                     }
                     if (filterColor) {
                        let c = card.getAttribute('data-color') || '';
                        if (c !== filterColor) match = false;
                     }
                     return match;
                 });

                 // Sort
                 sortCardsByStatusThenStock(filteredCards);

                 activeGrid.innerHTML = '';
                 filteredCards.forEach(card => activeGrid.appendChild(card));
                 const finalCount = filteredCards.length;
                 const countEl = document.querySelector('.collection-toolbar__count');
                 if (countEl) countEl.innerHTML = finalCount + ' Machine' + (finalCount !== 1 ? 's' : '');
               }
           }
         }
      })
      .catch(err => {
         console.error('AJAX Filter Error:', err);
         if (grid) grid.style.opacity = '1';
      });
  }

  // Bind change event to all selects with .js-filter-select
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('js-filter-select')) {
      let url = e.target.value;

      // If it is the sort dropdown, we must build the URL manually
      if (e.target.id === 'sort-by-select') {
         const currentUrl = new URL(window.location.href);
         currentUrl.searchParams.set('sort_by', e.target.value);
         url = currentUrl.toString();
      } else if (e.target.dataset.param) {
         // Collection colour/status selects hold only the value, so the page
         // source never links a filter URL for Googlebot to find.
         const currentUrl = new URL(window.location.href);
         if (e.target.value) currentUrl.searchParams.set(e.target.dataset.param, e.target.value);
         else currentUrl.searchParams.delete(e.target.dataset.param);
         currentUrl.searchParams.delete('page');
         url = currentUrl.toString();
      } else if (e.target.hasAttribute('data-keep-filters')) {
         // Manufacturer select: clean path, keep the active colour and status.
         const currentUrl = new URL(window.location.href);
         const targetUrl = new URL(url, window.location.origin);
         ['color', 'status'].forEach(key => {
           const value = currentUrl.searchParams.get(key);
           if (value) targetUrl.searchParams.set(key, value);
         });
         url = targetUrl.toString();
      }
      
      if (url) fetchAjaxFilter(url);
    }
  });

  // Bind input event to search page input for real-time typing
  const searchPageInputAjax = document.getElementById('search-page-input');
  if (searchPageInputAjax) {
    let searchAjaxTimer = null;
    searchPageInputAjax.addEventListener('input', function(e) {
       clearTimeout(searchAjaxTimer);
       searchAjaxTimer = setTimeout(() => {
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('q', buildSearchQuery(this.value));
          currentUrl.searchParams.set('type', 'product');
          fetchAjaxFilter(currentUrl.toString());
       }, 500); // 500ms debounce
    });
  }

  // Handle back button for AJAX history
  window.addEventListener('popstate', function(e) {
    if (e.state && e.state.path) {
      fetchAjaxFilter(e.state.path);
    } else {
      window.location.reload();
    }
  });

  // Initial load: if URL has filters, trigger fetch to aggregate pages
  const initialUrl = new URL(window.location.href);
  if (document.getElementById('products-grid') && (initialUrl.searchParams.has('color') || initialUrl.searchParams.has('status') || initialUrl.searchParams.has('q'))) {
    fetchAjaxFilter(window.location.href);
  }
});
